const isVisibleVt = (item: HTMLElement, container: HTMLElement) => {
    if (!item || !container) return false;
    const itemRect = item.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const result =
        itemRect.top >= container.scrollTop &&
        itemRect.bottom <= containerRect.bottom;
    return result;
};
const isVisibleHz = (item: HTMLElement, container: HTMLElement | null) => {
    if (!item || !container) return false;
    const itemRect = item.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const result =
        itemRect.left >= container.scrollLeft &&
        itemRect.right <= containerRect.right;
    return result;
};

const isVisible = (item: HTMLElement, container: HTMLElement) => {
    if (!item || !container) return false;
    const itemRect = item.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const result =
        itemRect.left >= container.scrollLeft &&
        itemRect.right <= containerRect.right &&
        itemRect.top >= container.scrollTop &&
        itemRect.bottom <= containerRect.bottom;
    return result;
};

const isLargerThanContainerViewVt = (
    item: HTMLElement,
    container: HTMLElement,
) => {
    const itemRect = item.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    return itemRect.height > containerRect.height;
};
const isLargerThanContainerViewHz = (
    item: HTMLElement,
    container: HTMLElement,
) => {
    return item.offsetLeft > container.clientWidth;
};
const isLargerThanContainerView = (item: HTMLElement, container: HTMLElement) =>
    isLargerThanContainerViewHz(item, container) &&
    isLargerThanContainerViewVt(item, container);

export {
    isLargerThanContainerView,
    isLargerThanContainerViewHz,
    isLargerThanContainerViewVt,
    isVisible,
    isVisibleHz,
    isVisibleVt,
};
